import { mapActions, mapGetters } from 'vuex';
import checkUserVerification from '@/mixins/checkUserVerification';
import { submitDeleteFeedback } from '@/feature/feedback/services/submitDeleteFeedback.js';

export default {
  mixins: [checkUserVerification],
  data() {
    return {
      accountDeleteLoading: false
    };
  },
  computed: {
    ...mapGetters({
      deleted: 'profile/accountDelete/deleted',
      feedbackReasons: 'profile/accountDelete/feedbackReasons',
      feedbackDetails: 'profile/accountDelete/feedbackDetails'
    }),
    step: {
      get() {
        return this.$store.state.profile.accountDelete.step;
      },
      set(value) {
        this.$store.commit('profile/accountDelete/setStep', value);
      }
    },
    accountDeleteButtons() {
      if (this.deleted) {
        return [
          {
            type: 'sendButton',
            props: {
              loading: this.accountDeleteLoading
            },
            events: {
              click: async () => {
                await this.logout();
                this.closeAccountDeleteDialog();
              }
            },
            text: this.$t('profileSection.menu.logout')
          }
        ];
      }

      switch (this.step) {
        case 1:
          return [
            {
              props: {
                class: 'error--text',
                loading: this.accountDeleteLoading,
                color: 'tetrary'
              },
              events: {
                click: () => {
                  this.step++;
                }
              },
              text: this.$t('profile.removeDialog.areYouSure.yes')
            },
            {
              events: {
                click: () => {
                  this.closeAccountDeleteDialog();
                }
              },
              text: this.$t('profile.removeDialog.areYouSure.no')
            }
          ];
        case 2:
          return [
            {
              props: {
                class: 'error--text',
                loading: this.accountDeleteLoading,
                color: 'tetrary'
              },
              events: {
                click: () => {
                  this.step++;
                }
              },
              text: this.$t('profile.removeDialog.deleteButton')
            },
            {
              events: {
                click: () => {
                  this.closeAccountDeleteDialog();
                }
              },
              text: this.$t('profile.removeDialog.cancelButton')
            }
          ];
        case 3:
          return [
            {
              props: {
                class: 'error--text',
                loading: this.accountDeleteLoading,
                color: 'tetrary',
                disabled: this.feedbackReasons.length === 0
              },
              events: {
                click: async () => {
                  const feedbackSent = await this.sendDeleteFeedback();
                  if (!feedbackSent) {
                    return;
                  }
                  await this.deleteAccount();
                }
              },
              text: this.$t('profile.removeDialog.feedback.confirm')
            },
            {
              events: {
                click: () => {
                  this.closeAccountDeleteDialog();
                }
              },
              text: this.$t('profile.removeDialog.feedback.cancel')
            }
          ];
      }
    }
  },
  methods: {
    ...mapActions({
      setDeleted: 'profile/accountDelete/setDeleted'
    }),

    async sendDeleteFeedback() {
      return submitDeleteFeedback({
        soulodyApi: this.$soulodyApi,
        store: this.$store,
        isMobileApp: this.isMobileApp,
        platformId: this.platformId,
        profileId: this.$auth.user.profileId,
        handleError: this.handleError
      });
    },

    async deleteAccount() {
      this.accountDeleteLoading = true;

      if (!(await this.checkUserVerification(false, true))) {
        this.accountDeleteLoading = false;
        return false;
      }

      await this.$http
        .delete('/v3/web-users')
        .then(() => {
          // New client returns null for 204 and throws HttpError for non-2xx
          this.setDeleted(true);
        })
        .catch(error => {
          this.handleError({ error, code: '0x0000002D' });
        })
        .finally(() => {
          this.accountDeleteLoading = false;
        });
    },
    closeAccountDeleteDialog() {
      this.dialog = false;
      this.$store.commit('profile/accountDelete/resetStore');
      this.step = 1;
    }
  }
};
